import {Marketplace, NegativePercentValueType, RatingValueType} from "../types/daily-feedback-reports-row.types";

export const marketplaces: Array<Marketplace> = [
  {
    id: 'wildberries',
    value: 'ВБ',
  },
  {
    id: 'ozon',
    value: 'Озон',
  }
]

export const negativePercentValueType: Array<NegativePercentValueType> = [
  1, 2, 3
]

export const ratingValueType: Array<RatingValueType> = [
  1, 2, 3
]
